<template>
  <div>
      <Page>
          <template #top>
              <CompetitionDates :competition="competition" />
          </template>
      </Page>
  </div>
</template>

<script>
import CompetitionDates from './CompetitionDates.vue'

export default {
    data() {
        return {
        }
    },
    props: ['competition'],
    components: {
        CompetitionDates
    }
}
</script>
